import axios from "axios";

const BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:8000/api/admin";
// const BASE_URL = "https://bubbl.cards/api/admin";


const axiosInstance = axios.create({ baseURL: BASE_URL });

export default axiosInstance;

